<template>
    <section>
        <div class="filters">
            <el-row :gutter="10" class="w-100">
                <el-col :xs="24" :sm="12" :md="8" :lg="4" :xl="4">
                    <el-input v-model="query.keyword" size="small" clearable class="mt-1 w-100"
                        placeholder="Nhập mã, tên, số điện thoại"></el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="4" :xl="4">
                    <el-select v-model="query.department_id" size="small" class="mt-1 w-100" clearable filterable
                               placeholder="Lọc Team">
                        <el-option
                            v-for="item in department"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="4" :xl="4">
                    <el-select v-model="query.level" clearable placeholder="Level" size="small" class="mt-1 w-100">
                        <el-option
                            v-for="item in levels"
                            :key="item.id"
                            :label="item.level"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="4" :xl="4">
                    <el-select v-model="query.year" placeholder="Lọc năm" size="small" class="mt-1 w-100">
                        <el-option v-for="y in years" :key="y" :label="'Năm ' + y" :value="y" />
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="4" :xl="4">
                    <el-select v-model="query.quarter" placeholder="Lọc quý" size="small" class="mt-1 w-100">
                        <el-option v-for="q in [1, 2, 3, 4]" :key="q" :label="'Quý ' + convertToRoman(q)" :value="q" />
                    </el-select>
                </el-col>
            </el-row>
        </div>

        <div class="charts-row">
            <div class="chart-col">
                <div v-if="loading" class="donut-skeleton">
                    <div class="circle"></div>
                    <div class="line"></div>
                </div>
                <ChartDonut v-else :series="donutStatus.series"
                    :labels="donutStatusLabels"
                    :colors="['#5b21b6', '#c4b5fd', '#22d3ee']" caption="Tỷ trọng tăng - giảm level" icon="people" />
            </div>
            <div class="chart-col">
                <div v-if="loading" class="donut-skeleton">
                    <div class="circle"></div>
                    <div class="line"></div>
                </div>
                <ChartDonut v-else :series="donutLevel.series" :labels="levelLabels"
                    :colors="['#c4b5fd', '#8b5cf6', '#f8a0d2', '#fbbe24', '#f97316', '#22d3ee', '#8b5cf6']"
                    caption="Tỷ trọng nhân sự tại các level" icon="users" />
            </div>
        </div>

        <div class="warning-toggle" v-if="warnings && warnings.length">
            <div class="ring-icon" @click="toggleWarning">
                <img src="@/assets/img/ring.webp" alt="warning bell" />
                <span class="notification-badge" v-if="warnings.length">{{ warnings.length }}</span>
            </div>
        </div>

        <WarningPanel v-if="warnings && warnings.length && showWarning" :warnings="warnings"/>

        <div class="section-card">
            <EmployeeProgressTable :items="items" :loading="loading" />
        </div>
    </section>

</template>

<script>
import ChartDonut from './chart/ChartDonut.vue'
import WarningPanel from './warning/WarningPanel.vue'
import EmployeeProgressTable from './table/EmployeeProgressTable.vue'
import {GET_DEPARTMENT_BY_DEPARTMENT_HEAD} from "@/core/services/store/profile.module";

import {
    GET_PROGRESS_STAFF_LIST,
    GET_LIST_LEVEL
} from "@/core/services/store/approve-team-level/approveTeamLevel.module";
import {mapGetters} from "vuex";
export default {
    name: 'EmployeeProgressTab',
    components: { ChartDonut, WarningPanel, EmployeeProgressTable },
    data() {
        const now = new Date().getFullYear();
        return {
            query: { keyword: '', department_id: null, level: null, year: now, quarter: 1 },
            department: [],
            levels: [],
            years: [],
            items: [],
            loading: false,
            donutStatus: { series: [100], options: {} },
            donutStatusLabels: ['Chưa có dữ liệu'],
            donutLevel: { series: [100], options: {} },
            levelLabels: ['Chưa có dữ liệu'],
            warnings: [],
            showWarning: true,
            _debounceTimer: null,
            _skipQueryWatch: false,
            positions: [
                {id: 14, name: 'Nhân viên'},
                {id: 32, name: 'Trưởng bộ phận'},
                {id: 16, name: 'Trưởng phòng'},
                {id: 34, name: 'Trưởng nhóm'},
            ],

            accountTypeMap: {
                14: [14], // Nhân viên
                32: [14,32,34], //Trưởng bộ phận
                16: [14,32,16,34], // Trưởng phòng
                34: [14], // Trưởng nhóm
            },
        };
    },
    mounted() {
        this.getCurrentQuarterAndYear();
        this.getDepartmentByUserId(this.currentUser.id);
        this.getListLevel();
        this.initFromRoute();
    },
    watch: {
        // Khi user thay đổi filter -> update URL
        query: {
            deep: true,
            handler() {
                if (this._skipQueryWatch) return;
                if (this._debounceTimer) clearTimeout(this._debounceTimer);
                this._debounceTimer = setTimeout(() => {
                    this.updateRoute();
                    this.reload();
                }, 0);
            },
        },

        // Khi URL thay đổi (back/forward/tab switch) -> update filter
        '$route.query': {
            handler(newQuery) {
                if (newQuery.tab !== 'employee') return;
                this.applyRouteToQuery(newQuery);
            },
        },
    },
    methods: {
        convertToRoman(num) {
            const romanNumerals = { 1: 'I', 2: 'II', 3: 'III', 4: 'IV' };
            return romanNumerals[num] || num;
        },

        calculateLevelCounts(dataCurrentLevel) {
            const levelMap = {
                'trainee': 0,
                'junior1': 1,
                'junior2': 2,
                'member1': 3,
                'member2': 4,
                'senior1': 5,
                'senior2': 6
            };

            const levelCounts = [0, 0, 0, 0, 0, 0, 0];

            if (!dataCurrentLevel) return levelCounts;

            Object.entries(dataCurrentLevel).forEach(([levelName, count]) => {
                const normalized = levelName.toLowerCase().trim();
                const level = normalized.match(/(senior|junior|member|trainee)/)?.[1];
                const number = normalized.match(/[12]/)?.[0];

                const normalizedBands = level === 'trainee' ? 'trainee' : `${level}${number || '2'}`;
                const index = levelMap[normalizedBands];

                if (index !== undefined) {
                    levelCounts[index] += count;
                }
            });

            return levelCounts;
        },
        getCurrentQuarterAndYear() {
            const now = new Date();
            const y = now.getFullYear();
            const s = 2025;
            const currentQuarter = (now.getMonth() / 3 | 0) + 1;
            const rq = this.$route?.query || {};
            if (rq.tab !== 'employee' || !rq.quarter) {
                this.query.quarter = currentQuarter;
            }
            this.query.year = (this.query.year && this.query.year >= s && this.query.year <= y) ? this.query.year : y;
            this.years = Array.from({ length: Math.max(1, y - s + 1) }, (_, i) => s + i);
        },
        clearData() {
            this.items = [];
            this.total = 0;
        },
        reload() {
            this.clearData();
            this.loading = true;
            const payload = {
                keyword: this.query.keyword,
                department_id: this.query.department_id,
                current_level: this.query.level,
                year: this.query.year,
                quarter: this.query.quarter,
                level_type: 1,
            };
            this.$store.dispatch(GET_PROGRESS_STAFF_LIST, payload).then((res) => {
                const s = res.data;
                this.items = s.data_detail;
                const data_level = s.data_level_up_and_down;
                this.total = s.total_level;

                const upLevel = data_level?.up_level || 0;
                const keepLevel = data_level?.keep_level || 0;
                const downLevel = data_level?.down_level || 0;
                const default_kepp = upLevel == 0 && downLevel == 0 && keepLevel == 0;

                if (!default_kepp) {
                    this.donutStatus.series = [upLevel, keepLevel, downLevel];
                    this.donutStatusLabels = ['NS tăng level', 'NS giữ nguyên level', 'NS giảm level'];
                } else {
                    this.donutStatus.series = [0, 100, 0];
                    this.donutStatusLabels = ['NS tăng level', 'NS giữ nguyên level', 'NS giảm level'];
                }

                // Tỷ trọng nhân sự tại các level
                const counts = this.calculateLevelCounts(s.data_current_level);
                const totalCounts = counts.reduce((sum, v) => sum + (Number(v) || 0), 0);
                if (totalCounts > 0) {
                    this.levelLabels = ['Trainee', 'Junior 1', 'Junior 2', 'Member 1', 'Member 2', 'Senior 1', 'Senior 2'];
                    this.donutLevel.series = counts;
                } else {
                    this.levelLabels = ['Chưa có dữ liệu'];
                    this.donutLevel.series = [100];
                }

                // Cảnh báo
                this.warnings = s.alerts;
            }).finally(() => {
                this.loading = false;
            });
        },

        toggleWarning() {
            this.showWarning = !this.showWarning;
        },

        getDepartmentByUserId(user_id) {
            this.$store.dispatch(GET_DEPARTMENT_BY_DEPARTMENT_HEAD, {
                user_id
            }).then((res) => {
                this.department = res.data;
            }).catch(() => {

            })
        },
        getListLevel() {
            this.$store.dispatch(GET_LIST_LEVEL, {
                type: 1
            }).then((res) => {
                this.levels = res.data;
            }).catch(() => {

            })
        },
        // Khởi tạo từ URL (chỉ gọi 1 lần khi mount)
        initFromRoute() {
            const q = this.$route.query;
            if (q.tab === 'employee') {
                this.applyRouteToQuery(q);
            } else {
                this.updateRoute();
            }
            this.reload();
        },
        // Áp dụng URL params vào query (Route -> State)
        applyRouteToQuery(routeQuery) {
            this._skipQueryWatch = true;
            const toInt = v => (v === undefined || v === null || v === '' ? null : parseInt(v, 10));
            this.query.keyword = routeQuery.keyword || '';
            this.query.department_id = toInt(routeQuery.department_id);
            this.query.level = toInt(routeQuery.level);
            this.query.year = toInt(routeQuery.year) || this.query.year;
            this.query.quarter = toInt(routeQuery.quarter) || this.query.quarter;
            this.$nextTick(() => { this._skipQueryWatch = false; });
        },
        // Cập nhật URL từ query (State -> Route)
        updateRoute() {
            const newQuery = {
                keyword: this.query.keyword || undefined,
                department_id: this.query.department_id || undefined,
                level: this.query.level || undefined,
                year: this.query.year || undefined,
                quarter: this.query.quarter || undefined,
                tab: 'employee'
            };
            const currentQuery = this.$route.query;
            if (JSON.stringify(newQuery) !== JSON.stringify(currentQuery)) {
                this.$router.replace({ query: newQuery }).catch(() => {});
            }
        },
    },
    computed: {
        ...mapGetters(['currentUser']),
    },
};
</script>

<style lang="scss" scoped>
.filters {
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}

.filters .el-col {
    margin-bottom: 8px;
}

.charts-row {
    display: grid;
    grid-template-columns: 1fr;
    gap: 16px;
    align-items: start;
    margin-bottom: 16px;
    width: 100%;
}

.chart-col {
    flex: 1;
    background: transparent;
    border: 0;
    padding: 0 12px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.donut-skeleton {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
    padding: 8px 0;
}

.donut-skeleton .circle {
    width: 220px;
    height: 220px;
    border-radius: 50%;
    background: linear-gradient(90deg, #f3f4f6 25%, #ede9fe 50%, #f3f4f6 75%);
    background-size: 400% 100%;
    animation: shimmer 1.2s ease-in-out infinite;
}

.donut-skeleton .line {
    width: 60%;
    height: 14px;
    border-radius: 7px;
    background: linear-gradient(90deg, #f3f4f6 25%, #ede9fe 50%, #f3f4f6 75%);
    background-size: 400% 100%;
    animation: shimmer 1.2s ease-in-out infinite;
}

@keyframes shimmer {
    0% { background-position: 100% 0; }
    100% { background-position: 0 0; }
}

@media (min-width: 1024px) {
    .charts-row {
        grid-template-columns: 1fr 1fr;
    }
}

@media (min-width: 1280px) {
    .charts-row {
        width: 66.67%;
    }
}

.warning-toggle {
    position: absolute;
    top: 70px;
    right: 10px;
    z-index: 1002;
}

.ring-icon {
    position: relative;
    cursor: pointer;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.ring-icon img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    transform: rotate(15deg);
    transition: transform 0.3s ease;
}

.ring-icon:hover img {
    transform: rotate(15deg) scale(1.1);
}

.notification-badge {
    position: absolute;
    top: 4px;
    right: 0;
    background: #ef4444;
    color: white;
    border-radius: 50%;
    width: 18px;
    height: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 10px;
    font-weight: 600;
}

.section-card {
    background: white;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    margin-bottom: 24px;
    overflow: hidden;
}
</style>
